"use client";

import { Core } from "@faire/design-tokens";
import React from "react";

import { createSVGIcon } from "../util";

/**
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=5%3A1723))
 * @trackcomponent
 * @lastsynced 2025-04-11T14:43:36.086Z
 * @optimized using svgo:^3.0.2
 */
export const Announcement = createSVGIcon(
  <>
    <path
      d="M4.286 8.179H6v6.857H4.286a3.428 3.428 0 1 1 0-6.857ZM6 8.179l15.717-5.476a1.016 1.016 0 0 1 1.426.786V18.94a1.01 1.01 0 0 1-1.372.802L6 15.036z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.31 21.369a4.826 4.826 0 0 1-3.721-6.335"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </>,
  "Announcement",
  { viewBox: "0 0 24 24", fill: "none", color: Core.icon.default } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);

/** @optimized using svgo:^3.0.2 */
export const AnnouncementMuted = createSVGIcon(
  <path
    d="M4.286 8.179H6v6.857H4.286a3.429 3.429 0 0 1 0-6.857ZM6 8.179l9.871-3.44M11 16.53l10.771 3.214a1.007 1.007 0 0 0 1.372-.802V4.501M9.31 21.369a4.8 4.8 0 0 1-2.19-.995M23 1 1 23"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "AnnouncementMuted",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
